import actionCreatorFactory from "../util/redux/action-factory";
import { reducerWithInitialState } from "../util/redux/typed-reducers";

import * as request from "../util/request";
import { ReduxState } from "./reducers";

export interface ActionButton {
    text?: string;
    icon?: {};
    showSpinner?: boolean;
}

/**
 * Action factory + actions
 */
const actionFactory = actionCreatorFactory("HypoMobiili/ActionButton");
export const SetShowActionButton = actionFactory<boolean>(
    "TOGGLE_SHOW_ACTION_BUTTON"
);
export const SetActionButton = actionFactory<ActionButton>("SET_ACTION_BUTTON");
export const SetActionButtonAndShow = actionFactory<ActionButton>(
    "SET_ACTION_BUTTON_AND_SHOW"
);
export const ActionButtonClicked = actionFactory("ACTION_BUTTON_CLICK");
export const ResetActionButtonClicked = actionFactory(
    "RESET_ACTION_BUTTON_CLICK"
);
export const SetActionButtonDisabled = actionFactory<boolean>(
    "TOGGLE_DISABLED_ACTION_BUTTON"
);

/**
 * The internal state of this reducer
 */
export class ActionButtonState {
    showActionButton: boolean;
    actionButtonClicked: boolean;
    actionButtonDisabled: boolean;
    actionButtonShowSpinner: boolean;
    actionButtonText?: string;
    actionButtonIcon?: {};
}

/**
 * The reducer.
 *
 * The module exports this as default
 */

const initialActionButtonState: ActionButtonState = {
    showActionButton: false,
    actionButtonClicked: false,
    actionButtonDisabled: false,
    actionButtonShowSpinner: false,
};

export const ActionButtonReducer = reducerWithInitialState(
    initialActionButtonState
)
    /**
     * Dispatch this action to set actionbutton content
     * but don't show it yet
     */
    .case(SetActionButton, (state, action) => {
        return {
            ...state,
            actionButtonText: action.payload.text,
            actionButtonIcon: action.payload.icon,
            actionButtonShowSpinner: !!action.payload.showSpinner,
        };
    })
    /**
     * Dispatch this action to set actionbutton content
     * and show it immediately
     */
    .case(SetActionButtonAndShow, (state, action) => {
        return {
            ...state,
            actionButtonText: action.payload.text,
            actionButtonIcon: action.payload.icon,
            showActionButton: true,
            actionButtonShowSpinner: !!action.payload.showSpinner,
        };
    })
    .case(SetShowActionButton, (state, action) => {
        return {
            ...state,
            showActionButton: action.payload.valueOf(),
            actionButtonClicked: false,
            actionButtonDisabled: false,
        };
    })
    /**
     * This action is dispatched when actionbutton is clicked
     */
    .case(ActionButtonClicked, (state, action) => {
        return {
            ...state,
            actionButtonClicked: true,
            actionButtonDisabled: true,
        };
    })
    /**
     * This action resets actionbutton state.
     * NOTE: Call this in ComponentWillReceiveProps
     * to reset actionbutton.
     */
    .case(ResetActionButtonClicked, (state, action) => {
        return {
            ...state,
            actionButtonClicked: false,
            actionButtonDisabled: false,
        };
    })
    .case(SetActionButtonDisabled, (state, action) => {
        return {
            ...state,
            actionButtonDisabled: action.payload.valueOf(),
        };
    });

export default ActionButtonReducer;

/**
 * Selectors
 */
export function showActionButton(state: ReduxState): boolean {
    return (
        (state && state.actionbutton && state.actionbutton.showActionButton) ||
        false
    );
}

export function actionButtonDisabled(state: ReduxState): boolean {
    return (
        (state &&
            state.actionbutton &&
            state.actionbutton.actionButtonDisabled) ||
        false
    );
}

export function actionButtonShowSpinner(state: ReduxState): boolean {
    return (
        (state &&
            state.actionbutton &&
            state.actionbutton.actionButtonShowSpinner) ||
        false
    );
}

export function actionButtonClicked(state: ReduxState): boolean {
    return (
        (state &&
            state.actionbutton &&
            state.actionbutton.actionButtonClicked) ||
        false
    );
}

export function getActionButton(
    state: ReduxState
): { text?: string; icon?: {} } | undefined {
    if (state && state.actionbutton) {
        const button = {
            text: state.actionbutton.actionButtonText,
            icon: state.actionbutton.actionButtonIcon,
        };
        return button;
    }

    return undefined;
}



// WEBPACK FOOTER //
// ./src/ducks/actionbutton.ts